import { render, staticRenderFns } from "./howToUseCard.vue?vue&type=template&id=4460a084&scoped=true"
import script from "./howToUseCard.vue?vue&type=script&lang=js"
export * from "./howToUseCard.vue?vue&type=script&lang=js"
import style0 from "./howToUseCard.vue?vue&type=style&index=0&id=4460a084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460a084",
  null
  
)

export default component.exports